module.exports = __webpack_public_path__ + "static/media/ad-03.73b2c106.jpg";